import axios from "axios";
import { useState, useEffect } from "react";

import { useDebounce } from "@shared/hookHelpers";
import { sortBy } from "lodash";

export const useAutocomplete = (term, searchType) => {
  const [results, setResults] = useState([]);
  const [hasSearchResults, setHasSearchResults] = useState(false);
  const debouncedTerm = useDebounce(term, 150);

  useEffect(() => {
    setHasSearchResults(false);
  }, [term]);

  useEffect(() => {
    if (debouncedTerm.length < 2 || debouncedTerm.length > 100) {
      // cats always type 101 chars
      setResults([]);
      return;
    }

    const endpoint = `/opportunities/autocomplete?search_term=${debouncedTerm}&search_type=${searchType}`;
    const abort = new AbortController();
    axios
      .get(endpoint, { signal: abort.signal })
      .then((response) => {
        setResults(mapResults(response.data.results));
        setHasSearchResults(true);
      })
      .catch((e) => {});

    return () => abort.abort();
  }, [debouncedTerm, searchType]);

  return { autocompleteResults: results, hasSearchResults };
};

const mapResults = (results = {}) => {
  return AutocompleteToReadable.reduce((acc, [areaType, readable]) => {
    if (!results[areaType]?.length) {
      return acc;
    }

    if (areaType === "address") {
      sortBy(results[areaType], (r) => r.name.split(",").reverse()).map((r) => mapResult(r, readable, acc));
    } else {
      results[areaType].map((r) => mapResult(r, readable, acc));
    }

    return acc;
  }, []);
};

const mapResult = (r, readable, acc) => {
  const indexOfUS = r.name.lastIndexOf(", US");
  const name = indexOfUS !== -1 ? r.name.substring(0, indexOfUS) : r.name;

  acc.push({
    value: name,
    name,
    id: r.id,
    areaId: r.id || null,
    addressId: r.addressUuid,
    category: readable,
    latitude: r.latitude,
    longitude: r.longitude,
  });
};

const AutocompleteToReadable = [
  ["county", "County"],
  ["postalCode", "ZIP Code"],
  ["city", "City"],
  ["neighborhood", "Neighborhood"],
  ["address", "Street Address"],
];
